import { render, staticRenderFns } from "./DamageReport.vue?vue&type=template&id=6b188914&scoped=true&"
import script from "./DamageReport.vue?vue&type=script&lang=js&"
export * from "./DamageReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b188914",
  null
  
)

export default component.exports